<template>
  <div
    class="mx-6 sm:m-auto p-5 bg-brand-strong-bg-overlay-80 backdrop-blur-3xl overflow-y-auto max-w-none sm:max-w-[590px] w-full rounded-[35px] h-auto max-h-[calc(100vh_-_5em)] gap-3 flex flex-col"
  >
    <div class="flex flex-row justify-between gap-3 self-stretch">
      <slot name="left"></slot>
      <header class="flex-1">
        <slot name="title"></slot>
      </header>

      <div
        v-if="!hideActions"
        class="flex flex-row-reverse justify-between gap-3 self-center"
      >
        <button
          class="p-2 w-auto h-auto bg-brand-bgdivider-20 text-basics-primary border-0 rounded-full"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          @click="close"
        >
          <Icon icon="mdi:close" class="size-8" />
        </button>

        <slot name="actions"></slot>
      </div>
    </div>

    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { Icon } from "@iconify/vue";

const emit = defineEmits<{
  close: [];
}>();

const _props = defineProps<{
  hideActions?: boolean;
}>();

const close = () => emit("close");
</script>
